import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'hb-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit {
  @Input() public category: string;
  @Input() public name: string;
  @Input() public invert?: boolean;
  @Input() public size?: number;

  /**
   * If you change this property, make sure to update the default width
   * and height of `.starman-icon` in `/style/guidelines/_icons.scss`
   */
  public readonly iconBaseSize = 24;
  public customStyle: Record<string, string> = {};

  constructor() {}

  ngOnInit() {
    if (this.size !== undefined) {
      this.customStyle = {
        transform: `scale(${this.size / this.iconBaseSize})`,
      };
    }
  }
}
